import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import 'video.js/dist/video-js.css';
import LinearProgressWithLabel from '../items/LinearProgressWithLabel';
import CircularProgress from '@mui/material/CircularProgress';
import Popover from '@mui/material/Popover';
import { Capacitor } from '@capacitor/core';
import Stack from '@mui/material/Stack';
import ContentContainer from './../items/ContentContainer';
import FormControlLabel from '@mui/material/FormControlLabel';
import SvgIcon from '@mui/material/SvgIcon';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import { ReactComponent as PlayIcon } from './../../assets/play.svg';
import { ReactComponent as PauseIcon } from './../../assets/pause.svg';
import { ReactComponent as NextIcon } from './../../assets/next.svg';
import { ReactComponent as PrevIcon } from './../../assets/prev.svg';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import { getOS, getPlatform, isIPhone, isPossiblyIPad } from '../../services/os';
import SearchFilters from './../items/SearchFilters';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import MuiToggleButton from "@mui/material/ToggleButton";
import { styled } from "@mui/material/styles";
import StopIcon from '@mui/icons-material/Stop';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import Waiting from './../items/Waiting';
import { ReactComponent as VolumeIcon } from './../../assets/volume.svg';
import NewWindow from 'react-new-window';
import MusicPlayer from './../player/MusicPlayer';
import sessionStore from './../../stores/session';
import environmentStore from './../../stores/environment';
import performanceStore from '../../stores/performance';
import musicStore from '../../stores/music';
import playerStore from '../../stores/player';
import { render } from '@testing-library/react';
import { decades } from '../../common/decades';
import singersStore from './../../stores/singers';
import settingsStore from '../../stores/settings';
import navigationStore from '../../stores/navigation';

const ToggleButton = styled(MuiToggleButton)({
  "&.Mui-selected, &.Mui-selected:hover": {
    background: "var(--text-color) !important",
    color: "rgb(18 ,18, 18) !important"
  }
});

function BackgroundMusic() {

  const itemsOnPage = 25;
  const isWaiting = musicStore((state) => state.isWaiting);
  const getSettings = settingsStore((state) => state.getSettings);
  const sessionToken = sessionStore((state) => state.sessionToken);
  const isEnvironmentSet = environmentStore((state) => state.isEnvironmentSet);
  const empty = musicStore((state) => state.empty);
  const getEnvironment = environmentStore((state) => state.getEnvironment);
  const environment = environmentStore((state) => state.environment);
  const streamUrl = musicStore((state) => state.streamUrl);
  const filterLanguages = musicStore((state) => state.filterLanguages);
  const setLanguageFilter = musicStore((state) => state.setLanguageFilter);
  const filterGenres = musicStore((state) => state.filterGenres);
  const setGenreFilter = musicStore((state) => state.setGenreFilter);
  const filterDecades = musicStore((state) => state.filterDecades);
  const setDecadeFilter = musicStore((state) => state.setDecadeFilter);
  const setAllLanguageFilters = musicStore((state) => state.setAllLanguageFilters);
  const setAllDecadeFilters = musicStore((state) => state.setAllDecadeFilters);
  const setAllGenreFilters = musicStore((state) => state.setAllGenreFilters);
  const isAllLanguageFiltersSet = musicStore((state) => state.isAllLanguageFiltersSet);
  const isAllGenreFiltersSet = musicStore((state) => state.isAllGenreFiltersSet);
  const isAllDecadeFiltersSet = musicStore((state) => state.isAllDecadeFiltersSet);
  const emptyFilter = musicStore((state) => state.emptyFilter);
  const isPlayerStopped = playerStore((state) => state.isStopped);
  const getTracks = musicStore((state) => state.getTracks);
  const totalCount = musicStore((state) => state.totalCount);
  const previousTrack = musicStore((state) => state.previousTrack);
  const currentTrack = musicStore((state) => state.currentTrack);
  const nextTrack = musicStore((state) => state.nextTrack);
  const isTracksSet = musicStore((state) => state.isSet);
  const toPrevious = musicStore((state) => state.toPrevious);
  const toNext = musicStore((state) => state.toNext);
  const isPlayerPlaying = playerStore((state) => state.isPlaying);
  const setFadeVolume = musicStore((state) => state.setFadeVolume);
  const tracks = musicStore((state) => state.tracks);
  const singers = singersStore((state) => state.singers);
  const getSingers = singersStore((state) => state.getSingers);

  const setIsPlaying = musicStore((state) => state.setIsPlaying);
  const setIsPaused = musicStore((state) => state.setIsPaused);
  const setFrom = musicStore((state) => state.setFrom);
  const currentTime = musicStore((state) => state.currentTime);
  const getStreamUrl = musicStore((state) => state.getStreamUrl);
  const settings = settingsStore((state) => state.settings);
  const setSettings = settingsStore((state) => state.setSettings);
  const currentVolume = musicStore((state) => state.currentVolume);
  const setVolume = musicStore((state) => state.setVolume);
  const isMusicOn = musicStore((state) => state.isMusicOn);
  const setCurrentTrack = musicStore((state) => state.setCurrentTrack);
  const setPreviousTrack = musicStore((state) => state.setPreviousTrack);
  const getNextTrack = musicStore((state) => state.getNextTrack);
  const setIsMusicOn = musicStore((state) => state.setIsMusicOn);
  const isPlaying = musicStore((state) => state.isPlaying);
  const isPaused = musicStore((state) => state.isPaused);
  const currentBuffer = musicStore((state) => state.currentBuffer);
  const isSaveable = musicStore((state) => state.isSaveable);
  const setIsSaveable = musicStore((state) => state.setIsSaveable);
  const getSaveableTrackCount = musicStore((state) => state.getSaveableTrackCount);
  const totalCountSaveable = musicStore((state) => state.totalCountSaveable);
  const isFading = musicStore((state) => state.isFading);
  const setMusicList = musicStore((state) => state.setMusicList);
  const getMusicList = musicStore((state) => state.getMusicList);
  const isWaitingInitial = musicStore((state) => state.isWaitingInitial);
  const isInGenres = musicStore((state) => state.isInGenres);
  const emptyMusicList = musicStore((state) => state.emptyMusicList);
  const setPaddingBottom = navigationStore((state) => state.setPaddingBottom);
  const isSaving = musicStore((state) => state.isSaving);
  const setIsSaving = musicStore((state) => state.setIsSaving);

  const [anchorAudioEl, setAnchorAudioEl] = React.useState(null);
  const [, updateState] = useState();
  const openAudioPopover = Boolean(anchorAudioEl);

  useEffect(() => {
    if (!settings) {
      getSettings(sessionToken);
    }
    if (!environment) {
      getEnvironment(sessionToken);
    }
    if (!singers) {
      getSingers(sessionToken);
    }
    setPaddingBottom("muvika-music", -30);
  }, []);

  useEffect(() => {
    setPaddingBottom("muvika-music", -30);
    setPaddingBottom("muvika-performances-list", -35);
  });

  useEffect(() => {
    if (settings) {
      setIsMusicOn(settings.music_enabled == 1);
    }
  }, [settings]);

  const lengthToMinutes = (length) => {
    const splitted = length.split(":");
    if (splitted.length == 3) {
      return splitted[1] + ":" + splitted[2];
    }
  };

  const getLength = (track) => {
    if (track) {
      return lengthToMinutes(track.length);
    }
    return "";
  };

  const toMMSS = (secs) => {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;

    return [hours, minutes, seconds]
      .map(v => v < 10 ? "0" + v : v)
      .filter((v, i) => v !== "00" || i > 0)
      .join(":");
  };

  const play = () => {
    if (!isPlayerStopped.isStopped) {
      setIsPaused(false);
    } else {
      if (isTracksSet) {
        if (isMusicOn) {
          if (streamUrl.length == 0) {
            console.log("get music stream url");
            getStreamUrl(sessionToken, currentTrack, singers[0], true);
          } else {
            setIsPaused(false);
          }
        }
      }
    }
  };

  const pause = () => {
    setIsPaused(true);
  };

  const handleMusicOn = () => {
    setIsPaused(isMusicOn);
    if (settings) {
      let newSettings = { ...settings };
      newSettings.music_enabled = !isMusicOn;
      setSettings(sessionToken, newSettings, false);
    }
    setIsMusicOn(!isMusicOn);
  };

  const handleLanguageChange = (id, isSelected) => {
    setPaddingBottom("muvika-music", -30);
    setIsSaveable(true);
    setLanguageFilter(id, !isSelected);
    getSaveableTrackCount(sessionToken);
  };

  const handleGenreChange = (id, isSelected) => {
    setPaddingBottom("muvika-music", -30);
    setIsSaveable(true);
    setGenreFilter(id, !isSelected);
    getSaveableTrackCount(sessionToken);
  };

  const handleDecadeChange = (id, isSelected) => {
    setPaddingBottom("muvika-music", -30);
    setIsSaveable(true);
    setDecadeFilter(id, !isSelected);
    getSaveableTrackCount(sessionToken);
  };

  const handleAllLanguagesChange = () => {
    if (environment) {
      setPaddingBottom("muvika-music", -30);
      setIsSaveable(true);
      setAllLanguageFilters(environment.track_languages);
      getSaveableTrackCount(sessionToken);
    }
  };

  const handleAllGenresChange = () => {
    if (environment) {
      setPaddingBottom("muvika-music", -30);
      setPaddingBottom("muvika-performances-list", -35);
      setIsSaveable(true);
      setAllGenreFilters(environment.genres);
      getSaveableTrackCount(sessionToken);
    }
  };

  const handleAllDecadesChange = () => {
    setPaddingBottom("muvika-music", -30);
    setPaddingBottom("muvika-performances-list", -35);
    setIsSaveable(true);
    setAllDecadeFilters(decades);
    getSaveableTrackCount(sessionToken);
  };

  const handleClickAudio = (event) => {
    setAnchorAudioEl(event.currentTarget);
  };

  const handleCloseAudio = () => {
    setAnchorAudioEl(null);
  };

  const handleSave = () => {
    setPaddingBottom("muvika-music", -30);
    setPaddingBottom("muvika-performances-list", -35);
    if (currentTrack) {
      setIsSaving(true);
      if (isInGenres(currentTrack)) {
        getTracks(sessionToken, itemsOnPage, singers[0]);
      } else {
        fader(() => {
          getTracks(sessionToken, itemsOnPage, singers[0]);
        });
      }
    } else {
      getTracks(sessionToken, itemsOnPage, singers[0]);
    }
  };

  const handleVolumeClick = (event) => {
    let rect = event.currentTarget.getBoundingClientRect();
    const x = (event.clientX - rect.left) / event.currentTarget.offsetWidth;
    setVolume(x);
    if (settings) {
      let newSettings = { ...settings };
      newSettings.music_volume = x * 100;
      setSettings(sessionToken, newSettings, false);
    }
  };

  const handleProgressClick = (event) => {
    let rect = event.currentTarget.getBoundingClientRect();
    const x = ((event.clientX - rect.left) * currentTrack.length.split(':').reduce((acc, time) => (60 * acc) + +time)) / event.currentTarget.offsetWidth;
    setFrom(x);
  };

  const currentProgress = () => {
    if (currentTrack && currentTrack.length) {
      return (currentTime / currentTrack.length.split(':').reduce((acc, time) => (60 * acc) + +time)) * 100;
    } else {
      return 0;
    }
  };

  const fader = (callback) => {
    let times = 10;
    let volume = currentVolume.currentVolume;
    let reduceBy = volume / times;
    let interval = setInterval(function () {
      if (times > 0) {
        volume = volume - reduceBy;
        setFadeVolume(volume);
        times = times - 1;
      } else {
        clearInterval(interval);
        callback();
      }
    }, 100);
  };

  const prev = () => {
    fader(() => {
      toPrevious(sessionToken, singers[0]);
    });
  };

  const next = () => {
    fader(() => {
      toNext(sessionToken, singers[0], itemsOnPage);
    });
  };

  const renderWaiting = () => {
    if (!isWaiting) {
      return <div>
        <b>{TR.cm_matching_tracks}: </b> {totalCountSaveable !== null ? totalCountSaveable : totalCount}
      </div>;
    } else {
      return <b>{TR.cm_matching_tracks}: ...</b>;
    }
  };

  const renderSaveButton = () => {
    if (isSaving || isWaiting) {
      return <div className="muvika-save-div">
        <Button className="muvika-save-button" variant="text" sx={{ color: "grey" }}><CircularProgress size={25} />
        </Button>
      </div>;
    } else if (isSaveable) {
      return <div className="muvika-save-div">
        <Button className="muvika-save-button" variant="text" color="success" onClick={
          handleSave
        }>{TR.cm_save}
        </Button>
      </div>;
    } else {
      return <div className="muvika-save-div">
        <Button className="muvika-save-button" variant="text" sx={{ color: "grey" }}>
          {TR.cm_save}
        </Button>
      </div>;
    }
  };

  const renderSearchFilters = () => {
    if (environment) {
      return <SearchFilters
        isAllLanguageFiltersSet={isAllLanguageFiltersSet}
        isAllGenreFiltersSet={isAllGenreFiltersSet}
        isAllDecadeFiltersSet={isAllDecadeFiltersSet}
        languages={environment.track_languages}
        filterLanguages={filterLanguages}
        genres={environment.genres}
        filterGenres={filterGenres}
        decades={decades}
        filterDecades={filterDecades}
        onAllLanguagesChange={handleAllLanguagesChange}
        onAllGenresChange={handleAllGenresChange}
        onAllDecadesChange={handleAllDecadesChange}
        onLanguageChange={handleLanguageChange}
        onGenreChange={handleGenreChange}
        onDecadeChange={handleDecadeChange}
      />;
    }
  };

  const renderProgressLine = () => {
    if (currentTrack) {
      return <LinearProgressWithLabel currentTime={toMMSS(currentTime)} buffer={currentBuffer * 100} value={currentProgress()} length={getLength(currentTrack)} onProgressClick={handleProgressClick} />;
    }
  };

  const renderPlayPause = () => {
    if (isPaused.isPaused) {
      return <Tooltip title={TR.cm_play}>
        <IconButton disabled={musicStore.getState().isFading || isSaving} color="white" component="label" size="small" onClick={play}>
          <SvgIcon className="muvika-icon" component={PlayIcon} />
        </IconButton>
      </Tooltip>;
    } else {
      return <Tooltip title={TR.cm_pause}>
        <IconButton disabled={musicStore.getState().isFading || isSaving} color="white" component="label" size="small" onClick={pause}>
          <SvgIcon className="muvika-icon" component={PauseIcon} />
        </IconButton>
      </Tooltip>;
    }
  };

  const renderWaitingForKaraoke = () => {
    if (!isPlayerStopped.isStopped) {
      return <div style={{ position: "relative" }}>
        <span className="muvika-background-music-waiting">
          {TR.cm_waiting_for_karaoke_to_finish}
        </span>
      </div>;
    }
  };

  const checkIos = (platform) => {
    return ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', 'iPad', 'iPhone', 'iPod'].includes(platform);
  };

  const renderVolumeButton = () => {
    if (!isIPhone() && !isPossiblyIPad() && !(Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios')) {
      return <Tooltip title={TR.cm_volume}>
        <IconButton color="white" component="label" size="small" onClick={handleClickAudio}>
          <SvgIcon className="muvika-icon" component={VolumeIcon} />
        </IconButton>
      </Tooltip>;
    }
  };

  const renderPlayer = () => {
    console.log(isMusicOn, isTracksSet, tracks.length > 2)
    if (isMusicOn && isTracksSet && tracks.length > 2) {
      return <div className="muvika-background-music-player">
        <Stack spacing={0}>
          <span>
            <Tooltip title={TR.cm_previous}>
              <IconButton disabled={isSaving} color="white" component="label" size="small" onClick={prev}>
                <SvgIcon className="muvika-icon" component={PrevIcon} />
              </IconButton>
            </Tooltip>
            {previousTrack ? previousTrack.artist + " - " + previousTrack.title : ""}
          </span>
          <span className="muvika-background-music-current">
            {renderPlayPause()}
            {currentTrack ? currentTrack.artist + " - " + currentTrack.title : ""}
          </span>
          <span>
            <Tooltip title={TR.cm_next}>
              <IconButton disabled={isSaving} color="white" component="label" size="small" onClick={next}>
                <SvgIcon className="muvika-icon" component={NextIcon} />
              </IconButton>
            </Tooltip>
            {nextTrack ? nextTrack.artist + " - " + nextTrack.title : ""}
          </span>
        </Stack>
        <Grid className="muvika-background-music-progress" container spacing={2}>
          <Grid item xs={1.5}>
            {renderVolumeButton()}
          </Grid>
          <Grid className="muvika-music-progress-grid" item xs={10.5}>
            {renderProgressLine()}
            {renderWaitingForKaraoke()}
          </Grid>
        </Grid>
      </div>;
    }
  };

  const renderContainer = () => {
    if (isMusicOn) {
      return <ContentContainer id="muvika-music" onScrollDown={() => {
      }} isFinished={true}>
        {renderPlayer()}
        {renderWaiting()}
        {renderSearchFilters()}
        <Popover
          open={openAudioPopover}
          anchorEl={anchorAudioEl}
          onClose={handleCloseAudio}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}

        >
          <div className="muvika-background-music-audio-progress">
            <LinearProgressWithLabel currentTime={"0%"} buffer={0} value={currentVolume.currentVolume * 100} length={"100%"} onProgressClick={handleVolumeClick} />
          </div>
        </Popover>
      </ContentContainer>;
    }
  };

  const renderMusicCheckBox = () => {
    if (isWaitingInitial) {
      return <Waiting />;
    } else {
      return <FormControlLabel onChange={handleMusicOn} control={<Checkbox checked={isMusicOn} />} label={TR.cm_enable_background_music} />;
    }
  };

  return (
    <div>
      <h3>{TR.cm_background_music}</h3>
      {renderMusicCheckBox()}
      {renderContainer()}
      {renderSaveButton()}
    </div>
  );
}

export default BackgroundMusic;